import AlertMessage from '../../OC/oc-alert-message';

export default ({ message, title = 'Note', type = 'info' }) => (
  <AlertMessage
    alertIcon
    dismissable={false}
    message={`<b>${title}:</b> ${message}`}
    style={{ marginBottom: '0px' }}
    textSize="13px"
    type={type}
  />
);
